import React from 'react';

const Delete = ({ width, height, color }) => (
  <svg width={width || '8'} height={height || '8'} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 2L2 6" stroke={color || '#C3C6D1'} strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 2L6 6" stroke={color || '#C3C6D1'} strokeWidth="0.7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Delete;